import { FieldInformation } from '../../general/models/field-information';

export class PartnerFieldsConfigurations {

  availableFieldsNames: string[];

  additionalFields: FieldInformation[];

  static createFromAny(data: any): PartnerFieldsConfigurations {
    if (!data) {
      return null;
    }
    const partnerFieldsConfigurations = new PartnerFieldsConfigurations();
    partnerFieldsConfigurations.availableFieldsNames = data.availableFieldsNames || [];
    partnerFieldsConfigurations.additionalFields = FieldInformation.createFromAnyArray(data.additionalFields);
    return partnerFieldsConfigurations;
  }

  isFieldAvailable(name: string): boolean {
    return name && this.availableFieldsNames?.some(fieldName => fieldName === name);
  }
}
